export default "__VITE_ASSET__BRG8MIQ9__"